var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoints2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8864_52821)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.8,
    y: 12.8008,
    width: 30.4,
    height: 30.4,
    rx: 15.2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1 13.5078C28.0421 13.5078 21.5094 20.0407 21.5094 28.099C21.5094 36.1572 28.0421 42.6901 36.1 42.6901C44.158 42.6901 50.6906 36.1572 50.6906 28.099C50.6906 20.0407 44.158 13.5078 36.1 13.5078ZM34.0102 35.4369C27.8589 31.3248 20.9838 23.7395 26.3623 18.3608C31.7407 12.9822 40.4593 12.9822 45.8378 18.3608C50.2074 22.7306 50.7078 29.1662 48.2951 34.5037C46.8787 37.6367 40.3334 39.6636 34.0102 35.4369Z",
    fill: "#FBC44D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8692 31.0042V23.7632H31.6999V31.0042H29.8692ZM27.1641 28.299V26.4684H34.405V28.299H27.1641ZM36.0878 32.5996V31.0042L39.8157 27.5525C40.1327 27.2456 40.3986 26.9695 40.6134 26.724C40.8316 26.4786 40.9969 26.2382 41.1094 26.003C41.2219 25.7644 41.2782 25.507 41.2782 25.2309C41.2782 24.924 41.2083 24.6598 41.0685 24.4382C40.9287 24.2132 40.7378 24.0411 40.4958 23.9218C40.2537 23.799 39.9793 23.7377 39.6725 23.7377C39.352 23.7377 39.0725 23.8024 38.8339 23.932C38.5952 24.0615 38.4111 24.2473 38.2816 24.4894C38.152 24.7314 38.0873 25.0195 38.0873 25.3536H35.9856C35.9856 24.6684 36.1407 24.0735 36.4509 23.5689C36.7611 23.0644 37.1958 22.674 37.7549 22.3979C38.314 22.1218 38.9583 21.9837 39.6878 21.9837C40.4378 21.9837 41.0907 22.1167 41.6464 22.3826C42.2055 22.6451 42.6401 23.0098 42.9503 23.4769C43.2606 23.9439 43.4157 24.4792 43.4157 25.0826C43.4157 25.478 43.3373 25.8684 43.1805 26.2536C43.027 26.6388 42.7526 27.0667 42.3572 27.5371C41.9617 28.0042 41.4043 28.565 40.685 29.2195L39.156 30.7178V30.7894H43.5537V32.5996H36.0878Z",
    fill: "#DD9700"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8864_52821",
    x: 0.799988,
    y: 0.800781,
    width: 70.4,
    height: 70.4004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.984314 0 0 0 0 0.768627 0 0 0 0 0.301961 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8864_52821"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8864_52821",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints2);
export default __webpack_public_path__ + "static/media/Points_2.1e10c1c707d3bc11d82b8bf06f7fca83.svg";
export { ForwardRef as ReactComponent };